

import { Directive, ElementRef, HostListener } from '@angular/core';


@Directive({
  selector: '[appFourDigit]',
})
export class FourDigitDirectiveDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) keypress(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue = inputElement.value;

    // Remove any non-digit characters from the input value
    const cleanedValue = inputValue.replace(/\D/g, '');

    // Limit the input to at most 4 digits
    const maxDigits = 4;
    const truncatedValue = cleanedValue.slice(0, maxDigits);

    // Update the input field with the truncated value
    inputElement.value = truncatedValue;


  }
}

